/**
 * DiasporaJourney — chip strip of neighbouring-country destinations
 * paired with an Indian city. Auto-hidden if the API returns none.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Plane } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const FLAGS = {
  "Sri Lanka":   "🇱🇰",
  "Nepal":       "🇳🇵",
  "Bhutan":      "🇧🇹",
  "Bangladesh":  "🇧🇩",
  "India":       "🇮🇳",
};

export default function DiasporaJourney({ slug, name }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!slug) return;
    let alive = true;
    axios.get(`${API}/api/geo/diaspora/pairings/${slug}`)
      .then((r) => alive && setItems(r.data?.items || []))
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [slug]);

  if (!items.length) return null;

  return (
    <section className="mt-10" data-testid="diaspora-journey">
      <div className="flex items-center gap-2 mb-3">
        <Plane className="w-4 h-4" />
        <h2 className="font-display text-xl">From {name} →</h2>
      </div>
      <p className="text-xs opacity-70 mb-3">
        Popular neighbouring-country destinations frequently paired with {name}.
      </p>
      <div className="flex flex-wrap gap-2">
        {items.map((it) => (
          <Link
            key={it.slug}
            to={`/l/${it.slug}`}
            className="inline-flex items-center gap-2 rounded-full border px-3 py-2 hover:brightness-95 transition text-sm"
            style={{ borderColor: "var(--wofy-border)", background: "var(--wofy-surface)" }}
            data-testid={`diaspora-${it.slug}`}
          >
            <span className="text-lg">{FLAGS[it.country] || "🌍"}</span>
            <span>
              <span className="font-medium block leading-tight">{it.name}</span>
              <span className="text-[10px] opacity-60 leading-tight">{it.country}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
